export default {
    meta: {
        title: '鱼你在一起-任务历史列表',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
